import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import breadcrumbs_45global from "/app/app/middleware/breadcrumbs.global.ts";
import cache_45handler_45global from "/app/app/middleware/cache-handler.global.ts";
import maintenance_45mode_45global from "/app/app/middleware/maintenance-mode.global.ts";
import org_45id_45global from "/app/app/middleware/orgId.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  breadcrumbs_45global,
  cache_45handler_45global,
  maintenance_45mode_45global,
  org_45id_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "advisor-access-required": () => import("/app/app/middleware/advisorAccessRequired.ts"),
  "developer-super-admin-required": () => import("/app/app/middleware/developer-super-admin-required.ts"),
  "login-required": () => import("/app/app/middleware/loginRequired.ts"),
  "my-benefit-demo-access-required": () => import("/app/app/middleware/myBenefitDemoAccessRequired.ts"),
  "seb-demo-access-required": () => import("/app/app/middleware/sebDemoAccessRequired.ts")
}